// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__KsW_O","navbar":"styles_navbar__LYtPI"};